// name, used as log prefix
export const NAME = 'web-view-event-bus'

export const ERROR_TIMEOUT = 'timeout'

export const ERROR_UNKNOWN = 'unknown'
